module.exports = __webpack_public_path__ + "assets/img/qr-android.d656f21d.png";